import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ReturnsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-860">
      <Header data-id="element-861" />

      <main className="flex-grow pt-32 pb-20" data-id="element-862">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-863">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-red-600 text-center uppercase mb-12" data-id="element-864">
            Returns & Refunds Policy
          </h1>

          <div className="space-y-10 text-gray-800 leading-relaxed" data-id="element-865">
            {/* Final Sale Items */}
            <section data-id="element-866">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-867">
                Final Sale Items
              </h2>
              <ul className="space-y-2" data-id="element-868">
                <li data-id="element-869">
                  • <strong data-id="element-870">Electronics</strong>,{' '}
                  <strong data-id="element-871">electronic headgear</strong>, and{' '}
                  <strong data-id="element-872">electronic chest protectors</strong> are{' '}
                  <strong data-id="element-873">non-returnable</strong>.
                </li>
                <li data-id="element-874">
                  • <strong data-id="element-875">Engraved</strong> or{' '}
                  <strong data-id="element-876">customized items</strong> are{' '}
                  <strong data-id="element-877">non-returnable</strong>.
                </li>
                <li data-id="element-878">
                  • <strong data-id="element-879">Used items</strong> are{' '}
                  <strong data-id="element-880">not eligible</strong> for return or exchange.
                </li>
              </ul>
            </section>

            {/* Dead on Arrival */}
            <section data-id="element-881">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-882">
                Dead on Arrival (DOA)
              </h2>
              <ul className="space-y-2" data-id="element-883">
                <li data-id="element-884">
                  • <strong data-id="element-885">Electronics</strong> that arrive defective are
                  eligible for <strong data-id="element-886">exchange only</strong>. Refunds are not
                  available for DOA items.
                </li>
              </ul>
            </section>

            {/* Returns */}
            <section data-id="element-887">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-888">
                Returns
              </h2>
              <ul className="space-y-2" data-id="element-889">
                <li data-id="element-890">
                  • <strong data-id="element-891">Reply to your confirmation order email</strong> to
                  request a return.
                </li>
                <li data-id="element-892">
                  • Returns are only on unused, without engravings, with the
                  packaging, <strong data-id="element-893">within 7 days</strong>.
                </li>
                <li data-id="element-894">
                  • <strong data-id="element-895">Shipping charges are non-refundable</strong> once an
                  item has shipped.
                </li>
                <li data-id="element-896">
                  • Approved refunds issued to a <strong data-id="element-897">credit card</strong>{' '}
                  are subject to a <strong data-id="element-898">5% return/transaction fee</strong>.
                </li>
              </ul>
            </section>

            {/* Warranties */}
            <section data-id="element-899">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-900">
                Warranties
              </h2>
              <ul className="space-y-2" data-id="element-901">
                <li data-id="element-902">
                  • Manufacturer warranties remain valid on engraved items.
                </li>
                <li data-id="element-903">
                  • Warranties for <strong data-id="element-904">Daedo socks and gloves</strong> cover{' '}
                  <strong data-id="element-905">normal wear and tear only</strong>.
                </li>
                <li data-id="element-906">
                  • For warranty claims or questions, contact info@tkdscore.com.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-907" />
    </div>;
}